/**
 * Material Images Handler
 * Manages image display for booking materials using Bootstrap Modal and LightGallery
 */

export default class MaterialImages {
  constructor() {
    this.modal = null;
    this.modalTitle = null;
    this.modalImg = null;
    this.lightGalleryContainer = null;
    this.lightGalleryInstance = null;

    this.init();
  }

  init() {
    // Get DOM elements
    this.modal = document.getElementById('materialImageModal');
    this.modalTitle = document.getElementById('materialImageModalLabel');
    this.modalImg = document.getElementById('materialImageModalImg');
    this.lightGalleryContainer = document.getElementById('materialLightGallery');

    if (!this.modal || !this.lightGalleryContainer) {
      return;
    }

    // Use event delegation for dynamic content
    document.addEventListener('click', (e) => {
      const button = e.target.closest('.btn-material-image');
      if (button) {
        e.preventDefault();
        this.handleImageButtonClick(button);
      }
    });

    // Cleanup LightGallery when Bootstrap modal is closed
    if (this.modal) {
      this.modal.addEventListener('hidden.bs.modal', () => {
        this.cleanupLightGallery();
      });
    }
  }

  handleImageButtonClick(button) {
    try {
      const materialName = button.dataset.materialName;
      const imagesJson = button.dataset.images;

      if (!imagesJson) {
        return;
      }

      const images = JSON.parse(imagesJson);
      const imageUrls = Object.values(images);

      if (imageUrls.length === 0) {
        return;
      }

      if (imageUrls.length === 1) {
        // Single image: use Bootstrap Modal
        this.showBootstrapModal(materialName, imageUrls[0]);
      } else {
        // Multiple images: use LightGallery
        this.showLightGallery(materialName, imageUrls);
      }
    } catch (error) {
    }
  }

  showBootstrapModal(title, imageUrl) {
    this.modalTitle.textContent = title;
    this.modalImg.src = imageUrl;
    this.modalImg.alt = title;

    const bsModal = new bootstrap.Modal(this.modal);
    bsModal.show();
  }

  showLightGallery(title, imageUrls) {
    // Clear previous gallery
    this.cleanupLightGallery();
    this.lightGalleryContainer.innerHTML = '';

    // Build gallery HTML
    imageUrls.forEach((url, index) => {
      const link = document.createElement('a');
      link.href = url;
      link.dataset.src = url;
      link.dataset.subHtml = `<h4>${title}</h4>`;
      this.lightGalleryContainer.appendChild(link);
    });

    // Initialize LightGallery
    if (window.lightGallery) {
      this.lightGalleryInstance = window.lightGallery(this.lightGalleryContainer, {
        selector: 'a',
        speed: 500,
        download: false,
        counter: true,
        getCaptionFromTitleOrAlt: false
      });

      // Open gallery immediately
      setTimeout(() => {
        if (this.lightGalleryInstance) {
          this.lightGalleryInstance.openGallery(0);
        }
      }, 50);
    } else {
    }
  }

  cleanupLightGallery() {
    if (this.lightGalleryInstance) {
      this.lightGalleryInstance.destroy();
      this.lightGalleryInstance = null;
    }
    if (this.lightGalleryContainer) {
      this.lightGalleryContainer.innerHTML = '';
    }
  }
}
